const ErrorPage = () => {
  return <div className="flex items-center p-5">Page not found</div>
}

export default ErrorPage
